export const OPEN_MASS_ITEM_LOCATION_MODAL = 'OPEN_MASS_ITEM_LOCATION_MODAL';
export const CLOSE_MASS_ITEM_LOCATION_MODAL = 'CLOSE_MASS_ITEM_LOCATION_MODAL';

export const SHOW_MASS_ITEM_MESSAGE_MODAL = 'SHOW_MASS_ITEM_MESSAGE_MODAL';

export const SET_TARGET_LOCATION = 'SET_TARGET_LOCATION';
export const MASS_CREATE_ITEMS = 'MASS_CREATE_ITEMS';

export const PROCESSING_MASS_CREATE_ITEMS = 'PROCESSING_MASS_CREATE_ITEMS';